import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../../environments/environment';

@Injectable()
export class GeneralLetterInformationForm extends AppForm {
  constructor() {
    super({
      description: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      })
    });
  }
}
